import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is handled via HttpOnly cookies set by the backend (jwt_token, session_token).
// withCredentials ensures these cookies are sent on every request.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
